module.exports = "/_next/static/images/data-18020b65f48992aa5473fe0754aaa9d8.svg";